import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";

interface IStudentsState {
  showHelp: boolean;
}

const initialState: IStudentsState = {
  showHelp: true,
};
export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleShowHelp(state) {
      state.showHelp = !state.showHelp;
    },
  },
});

export const selectShowHelp = (state: RootState) => state.ui.showHelp;

export const { toggleShowHelp } = uiSlice.actions;

export default uiSlice.reducer;
